import React from 'react';
import { PropTypes } from 'prop-types';
import { Dialog, RaisedButton } from "material-ui";

/**
 * エラーのダイアログ.
 * ※ <Error title={'タイトル'} message={'内容'} /> で使用する.
 *
 * @class Error
 * @extends {React.Component}
 */
class Error extends React.Component {
  handleClose = () => {
    this.props.errorActions.close();
  };

  componentWillMount = () => {
    // まず表示.
    this.props.errorActions.alert(this.props.title, this.props.message);
  }

  getErrorMessage(err) {
    if (err === "User already exists") {
      return "この介護保険事業所番号は既に登録されています。";
    }

    return err;
  }

  render() {
    return (
      <Dialog
        title={this.props.error.errorTitle}
        open={this.props.error.displayError}
      >
        <div>
          {this.getErrorMessage(this.props.error.errorMessage)}
        </div>
        <RaisedButton
          type="button"
          label="閉じる"
          primary={true}
          onClick={() => this.handleClose()}
        />
      </Dialog>
    );
  }
}

Error.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default Error;


// WEBPACK FOOTER //
// ./src/components/common/Error.js